module.exports = __webpack_public_path__ + "img/IMG_8973.d9fc2331.jpg";